import { render, staticRenderFns } from "./doc.vue?vue&type=template&id=c3410436&scoped=true&"
import script from "./doc.vue?vue&type=script&lang=js&"
export * from "./doc.vue?vue&type=script&lang=js&"
import style0 from "./doc.vue?vue&type=style&index=0&lang=less&"
import style1 from "./doc.vue?vue&type=style&index=1&id=c3410436&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3410436",
  null
  
)

export default component.exports